import "../../../../src/styles/main.css";
import * as React from 'react';
export default {
  React
};